import { FormattedMessage } from 'react-intl';
import { Outlet, generatePath } from 'react-router-dom';

import { ContentWithStickyHeader } from '@sorare/core/src/atoms/layout/ContentWithStickyHeader';
import { Tab, TabBar } from '@sorare/core/src/atoms/navigation/TabBar';
import {
  NBA_SCOUTING_CENTER_SCORES,
  NBA_SCOUTING_CENTER_SCORES_GAMEID,
  NBA_SCOUTING_CENTER_STATS,
} from '@sorare/core/src/constants/__generated__/routes';
import { navLabels } from '@sorare/core/src/lib/glossary';

enum ScoutingCenterTabs {
  SCORES = 'SCORES',
  STATS = 'STATS',
}

const tabs = [
  {
    tab: ScoutingCenterTabs.STATS,
    label: navLabels.stats,
    to: generatePath(NBA_SCOUTING_CENTER_STATS),
    matches: [NBA_SCOUTING_CENTER_STATS],
  },
  {
    tab: ScoutingCenterTabs.SCORES,
    label: navLabels.scores,
    to: generatePath(NBA_SCOUTING_CENTER_SCORES),
    matches: [NBA_SCOUTING_CENTER_SCORES, NBA_SCOUTING_CENTER_SCORES_GAMEID],
  },
];

const ScoutingCenterLayout = () => {
  return (
    <ContentWithStickyHeader
      header={
        <TabBar variant="flat" fullWidth ignoreQueryParams>
          {tabs.map(({ to, tab, label, matches }) => (
            <Tab key={tab} to={to} matches={matches}>
              <FormattedMessage {...label} />
            </Tab>
          ))}
        </TabBar>
      }
    >
      <Outlet />
    </ContentWithStickyHeader>
  );
};

export default ScoutingCenterLayout;
